import React, { useState, useEffect } from 'react';
import { EntidadeEntidade } from '../../../entidades';
import { Alert, Box, Col, Row, StaticField } from '@intech/web-ui';

import { LoadingComponent } from '../../../components/LoadingComponent';

interface IProps {
  entidade: EntidadeEntidade
}

export const Endereco: React.FC<IProps> = ({
  entidade
}) => {

  const [AlertText, setAlertText] = useState<string>("");
  const [Entidade, setEntidade] = useState<EntidadeEntidade>();

  useEffect(() => {
    (async () => {
      try {
        setEntidade(entidade);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, []);

  function renderEndereco() {
    if (Entidade !== undefined) {

      return (
        <Box title={"Endereço"}>

          <Row>
            <Col>
              <StaticField
                value={Entidade.END_ENTID}
                title={"Endereço"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Entidade.NR_END_ENTID}
                title={"Número"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Entidade.COMP_END_ENTID}
                title={"Complemento"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Entidade.BAIRRO_ENTID}
                title={"Bairro"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Entidade.CID_ENTID}
                title={"Cidade"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Entidade.UF_ENTID}
                title={"UF"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Entidade.CEP_ENTID}
                title={"CEP"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>
        </Box>
      );
    }

    if (AlertText !== "") {
      return (
        <Alert type={"danger"}>
          {AlertText}
        </Alert>
      );
    }

    return <LoadingComponent />;
  }

  return renderEndereco();
}